import DefaultComparer from '../system/DefaultComparer';
import DefaultEqualityComparer from '../system/DefaultEqualityComparer';
export default class IterableUtils {
    static compare(array1, array2, comparer = DefaultComparer.compare) {
        const array2Iterator = array2[Symbol.iterator]();
        let item2 = array2Iterator.next();
        for (const item1 of array1) {
            if (item2.done) {
                return 1;
            }
            const result = comparer(item1, item2.value);
            if (result !== 0) {
                return result;
            }
            item2 = array2Iterator.next();
        }
        if (!item2.done) {
            return -1;
        }
        return 0;
    }
    ;
    static equal(array1, array2, equalityComparer = DefaultEqualityComparer.equal) {
        const array2Iterator = array2[Symbol.iterator]();
        let item2 = array2Iterator.next();
        for (const item1 of array1) {
            if (item2.done) {
                return false;
            }
            const result = equalityComparer(item1, item2.value);
            if (result !== true) {
                return false;
            }
            item2 = array2Iterator.next();
        }
        if (!item2.done) {
            return false;
        }
        return true;
    }
    ;
    static isIterable(obj) {
        if (obj === null || obj === undefined) {
            return false;
        }
        return typeof obj[Symbol.iterator] === 'function';
    }
    ;
}
//# sourceMappingURL=IterableUtils.js.map